import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Logger} from '../utils/logger';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
  selector: 'app-empty-component',
  template: `
      <router-outlet></router-outlet>
  `,
})
export class EmptyComponent {
  constructor() {
    const route = inject(ActivatedRoute);

    route.params.subscribe(params => {
      Logger.log('EMPTU PARAMS: ', params);
    });
  }
}
